import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { LIST_VIEW_TYPE } from "@constants";
import { IconButton, Tooltip } from "@mzc-pdc/ui";
import theme from "@styles/theme";
import { IconAllView, IconHierarchy } from "@mzc-cloudplex/icons";

const ViewSelector = ({ activeView: activeView_, onClickOutside, onClickToggleButton, onClickViewType }) => {
    const { t } = useTranslation();
    const [showDropdownLayer, setShowDropdownLayer] = useState(false);
    const activeView = useMemo(() => activeView_?.toLowerCase(), [activeView_]);

    return (
        <React.Fragment>
            <Tooltip
                title={
                    activeView === LIST_VIEW_TYPE.LIST
                        ? `${t(`common::label::Grouping View mode`, "Grouping View mode")}`
                        : `${t(`common::label::View All mode`, "View All mode")}`
                }
            >
                <IconButton
                    size={"medium"}
                    variant={"contained"}
                    sx={{
                        backgroundColor: theme.palette.primary.light,
                        "&:hover, &:focus, &:active, .Mui-Selected": {
                            backgroundColor: theme.palette.primary.light,
                        },
                        marginRight: 1,
                    }}
                    onClick={(e) => {
                        activeView === LIST_VIEW_TYPE.LIST
                            ? onClickViewType(LIST_VIEW_TYPE.HIERARCHY)
                            : onClickViewType(LIST_VIEW_TYPE.LIST);
                    }}
                >
                    {activeView === LIST_VIEW_TYPE.LIST ? (
                        <IconHierarchy size={16} htmlColor={"#fff"} />
                    ) : (
                        <IconAllView size={16} htmlColor={"#fff"} />
                    )}
                </IconButton>
            </Tooltip>
        </React.Fragment>
    );
};

ViewSelector.propTypes = {
    activeView: PropTypes.string,
    onClickOutside: PropTypes.func,
    onClickToggleButton: PropTypes.func,
    onClickViewType: PropTypes.func,
};

ViewSelector.defaultProps = {};

export default ViewSelector;
